import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize, shareReplay, tap } from 'rxjs/operators';
import { AuthResponse } from '../shared/models/users/auth-response';
import { AuthApiService } from './auth-api.service';

@Injectable({
  providedIn: 'root',
})
export class AuthTokenRefreshService {
  private static readonly retryHeader = 'X-Retry-After-Refresh';
  private refreshInFlight: Observable<AuthResponse> | null = null;

  constructor(private authApi: AuthApiService) {}

  shouldAttemptRefresh(request: HttpRequest<unknown>, error: HttpErrorResponse): boolean {
    if (error.status !== 401) {
      return false;
    }

    if (request.headers.has(AuthTokenRefreshService.retryHeader)) {
      return false;
    }

    const path = request.url.toLowerCase();
    if (path.includes('/platform/auth')) {
      return false;
    }

    return localStorage.getItem('token') !== null;
  }

  refreshToken(): Observable<AuthResponse> {
    if (!this.refreshInFlight) {
      this.refreshInFlight = this.authApi.refresh().pipe(
        tap((response) => this.persistAuthResponse(response)),
        finalize(() => {
          this.refreshInFlight = null;
        }),
        shareReplay(1)
      );
    }

    return this.refreshInFlight;
  }

  persistAuthResponse(response: AuthResponse): void {
    localStorage.setItem('token', response.accessToken);
    localStorage.setItem('tokenExpires', String(response.expiresAt));
  }

  cloneRequestWithUpdatedToken(request: HttpRequest<unknown>): HttpRequest<unknown> {
    return request.clone({
      setHeaders: {
        [AuthTokenRefreshService.retryHeader]: 'true',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    });
  }
}
